import AccessoryDetails from "./AccessoryDetails";
export default AccessoryDetails;
